import { createSlice } from '@reduxjs/toolkit';

import { thunks } from './thunks';
import { selectors } from './selectors';

const initialState = {
  token: null,
  refreshToken: null,
  loading: false,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUnauthorized() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunks.logIn.fulfilled, (state, action) => {
        state.token = action.payload.data.accessToken;
        state.refreshToken = action.payload.data.refreshToken;
      })
      .addCase(thunks.signUp.fulfilled, (state, action) => {
        state.token = action.payload.data.accessToken;
        state.refreshToken = action.payload.data.refreshToken;
      })
      .addCase(thunks.refreshToken.fulfilled, (state, action) => {
        state.token = action.payload.accessToken;
        state.refreshToken = action.payload.refreshToken;
      })
      .addCase(thunks.logout.pending, (state) => {
        state.loading = true;
      })
      .addCase(thunks.logout.fulfilled, (state) => {
        state.loading = false;
        Object.assign(state, initialState);
      })
      .addCase(thunks.logout.rejected, (state) => {
        state.loading = false;
      })
      .addCase(thunks.googleLogin.fulfilled, (state, action) => {
        const { accessToken } = action.payload.data;
        state.token = accessToken;
      })
      .addCase(thunks.googleSignUp.fulfilled, (state, action) => {
        const { accessToken } = action.payload.data;
        state.token = accessToken;
      })
      .addCase(thunks.appleLogin.fulfilled, (state, action) => {
        const { accessToken } = action.payload.data;
        state.token = accessToken;
      })
      .addCase(thunks.appleSignUp.fulfilled, (state, action) => {
        const { accessToken } = action.payload.data;
        state.token = accessToken;
      });
  },
});

const auth = {
  actions: slice.actions,
  thunks,
  selectors,
  loading: (state) => state.auth.loading,
};

export { auth };
export default slice.reducer;
